import { useState } from "react";
import { PRODUCTS, PRODUCT_IDS } from "@/content/products";
import { Swap } from "@/components/site/ExplorerFrame";
import { Placeholder } from "@/components/site/Placeholder";
import { ActionLink, Mono } from "@/components/site/primitives";
import { cn } from "@/lib/utils";

const Row = ({ p, on, onSelect }) => (
  <button type="button" onClick={() => onSelect(p.id)} onFocus={() => onSelect(p.id)} aria-pressed={on} data-testid={`discovery-${p.id}`}
    className={cn("grid w-full gap-2 border p-4 text-left transition-colors sm:grid-cols-12 sm:items-baseline sm:gap-4",
      on ? "border-o-accent bg-o-soft" : "border-o-line bg-o-surface hover:border-o-strong")}>
    <span className="text-sm sm:col-span-4">{p.activity}</span>
    <span className="text-sm text-o-dim sm:col-span-5">{p.responsibilityShort}</span>
    <span className="font-display text-lg font-bold sm:col-span-3 sm:text-right">{p.name}</span>
  </button>
);

export const ProductDiscovery = () => {
  const [sel, setSel] = useState("briefcase");
  const p = PRODUCTS[sel];
  return (
    <div className="grid gap-6 lg:grid-cols-12" data-testid="product-discovery">
      <div className="lg:col-span-7">
        <div className="border border-o-strong bg-o-surface p-5">
          <Mono accent>Shared methods</Mono>
          <p className="mt-2 font-display text-xl font-bold">Human Structure · General Ordo</p>
          <p className="mt-1 text-sm text-o-dim">One body of method, applied to very different human activities.</p>
        </div>
        <div aria-hidden className="ml-8 h-6 border-l border-o-strong" />
        <div className="hidden grid-cols-12 gap-4 px-4 pb-2 sm:grid">
          <Mono className="col-span-4">Human activity</Mono>
          <Mono className="col-span-5">Technological responsibility</Mono>
          <Mono className="col-span-3 text-right">Product</Mono>
        </div>
        <div className="space-y-2">
          {PRODUCT_IDS.map((id) => <Row key={id} p={PRODUCTS[id]} on={sel === id} onSelect={setSel} />)}
        </div>
      </div>
      <div className="lg:col-span-5" aria-live="polite">
        <Swap k={sel} className="h-full">
          <div className={cn(p.theme, "flex h-full flex-col bg-o-bg p-5 text-o-text sm:p-6")} data-testid="discovery-preview">
            <Mono accent>{p.name} · its own setting</Mono>
            <Placeholder label={p.placeholder} ratio="4 / 3" className="mt-4" />
            <p className="mt-5 text-sm text-o-dim">{p.tagline}</p>
            <ActionLink to={p.path} testid={`discovery-open-${p.id}`} className="mt-6 self-start">Open {p.name}</ActionLink>
          </div>
        </Swap>
      </div>
    </div>
  );
};
